import {GoogleProcessingStatusEnum} from './google-processing-type';

export const googleProcessingLocationsLoadingStatuses = [
    GoogleProcessingStatusEnum.LocationsLoadingActive,
    GoogleProcessingStatusEnum.LocationsLoadingFailed,
];
